import { useEffect } from "react";
import { message } from "antd";
import type { Room } from "livekit-client";

/// Publishes the proctor's microphone and/or camera (each only if the proctor wants it) while addressing candidates,
/// and lets only the target candidates subscribe to it; everyone else in the room is denied at the SFU.
export const useStaffTalk = (room: Room | null, targets: string[], mic: boolean, camera: boolean) => {
  const key = targets.join(",");

  useEffect(() => {
    if (!room) return;
    const local = room.localParticipant;
    const active = targets.length > 0;
    local.setTrackSubscriptionPermissions(
      false,
      targets.map((identity) => ({ participantIdentity: identity, allowAll: true }))
    );
    local.setMicrophoneEnabled(active && mic).catch(() => {
      if (active && mic) message.error("Mikrofon nije dostupan.");
    });
    local.setCameraEnabled(active && camera).catch(() => {
      if (active && camera) message.error("Kamera nije dostupna.");
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [room, key, mic, camera]);

  useEffect(() => {
    if (!room) return;
    return () => {
      room.localParticipant.setMicrophoneEnabled(false).catch(() => undefined);
      room.localParticipant.setCameraEnabled(false).catch(() => undefined);
    };
  }, [room]);
};
